/* Qualified Apparel — every behaviour the static build carried, in one file.
   Each block no-ops if its markup is not on the page, so this loads once in
   the layout rather than per template. All motion respects reduced motion. */

/* ── mobile menu ──────────────────────────────────────────────
   Below 720px the nav links live in a panel behind a button. The CTA stays
   in the bar; it is the one thing that should never need a tap to find. */
(function () {
  var btn  = document.querySelector('.nav__burger');
  var menu = document.getElementById('navMenu');
  if (!btn || !menu) return;

  function set(open) {
    menu.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  btn.addEventListener('click', function () {
    var open = btn.getAttribute('aria-expanded') !== 'true';
    set(open);
    // Same rule in reverse: opening the menu closes the search panel.
    var sf = document.getElementById('navSearch');
    var sb = document.getElementById('navSearchBtn');
    if (open && sf && !sf.hidden) { sf.hidden = true; if (sb) sb.setAttribute('aria-expanded', 'false'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { set(false); btn.focus(); }
  });
  document.addEventListener('click', function (e) {
    if (!menu.contains(e.target) && !btn.contains(e.target)) set(false);
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 900) set(false);   // matches the CSS breakpoint
  });
})();

/* ── scroll reveal ───────────────────────────────────────────── */
(function () {
  var els = document.querySelectorAll('.rv');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (e) { e.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
  els.forEach(function (e, i) {
    e.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
    io.observe(e);
  });
})();

/* ── heading markers ─────────────────────────────────────────── */
(function () {
  var els = [].slice.call(document.querySelectorAll('.hl, .ringed'));
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('is-lit'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-lit'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.2 });
  els.forEach(function (e) { io.observe(e); });
})();

/* ── hero loop ───────────────────────────────────────────────
   No autoplay attribute in the markup on purpose: reduced motion keeps the
   poster frame instead. Pauses when scrolled out of view. */
(function () {
  var v = document.getElementById('heroFilm');
  if (!v) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  v.play().catch(function () {});
  if (!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.isIntersecting ? v.play().catch(function () {}) : v.pause(); });
  }, { threshold: 0.1 }).observe(v);
})();

/* ── shop filters ────────────────────────────────────────────
   Empty categories resolve to a state that routes to the custom side rather
   than a dead end. */
(function () {
  var grid  = document.getElementById('shopGrid');
  var empty = document.getElementById('shopEmpty');
  if (!grid || !empty) return;

  var head   = document.getElementById('emptyHead');
  var body   = document.getElementById('emptyBody');
  var tiles  = [].slice.call(grid.querySelectorAll('.tile'));
  var radios = [].slice.call(document.querySelectorAll('input[name="cat"]'));

  function apply(cat) {
    var shown = 0;
    tiles.forEach(function (t) {
      var on = (cat === 'all' || t.dataset.cat === cat);
      t.classList.toggle('tile--off', !on);
      if (on) shown++;
    });
    var isEmpty = shown === 0;
    grid.hidden  = isEmpty;
    empty.hidden = !isEmpty;
    if (isEmpty) {
      var label = (radios.filter(function (r) { return r.checked; })[0] || {}).dataset || {};
      if (head && label.emptyHead) head.textContent = label.emptyHead;
      if (body && label.emptyBody) body.textContent = label.emptyBody;
    }
  }
  radios.forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) apply(r.value); });
  });
  // Firefox and bfcache restore the previous radio on reload, so sync to
  // whatever is actually checked rather than assuming all.
  var checked = radios.filter(function (r) { return r.checked; })[0];
  apply(checked ? checked.value : 'all');
})();

/* ── reviews ─────────────────────────────────────────────────── */
(function () {
  var band  = document.getElementById('reviews');
  var stage = document.getElementById('saysStage');
  var dots  = document.getElementById('saysDots');
  if (!band || !stage || !dots) return;

  var quotes = [].slice.call(stage.querySelectorAll('.quote'));
  var tabs   = [].slice.call(dots.querySelectorAll('button'));
  if (quotes.length < 2) return;

  var i = 0, timer = null, paused = false;
  var HOLD = 5200;

  function show(n) {
    i = (n + quotes.length) % quotes.length;
    quotes.forEach(function (q, k) { q.classList.toggle('is-on', k === i); });
    tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
  }
  function tick() { if (!paused) show(i + 1); }
  function start() { if (timer) clearInterval(timer); timer = setInterval(tick, HOLD); }

  tabs.forEach(function (t, k) {
    t.addEventListener('click', function () { show(k); start(); });
  });
  band.addEventListener('mouseenter', function () { paused = true; });
  band.addEventListener('mouseleave', function () { paused = false; });

  show(0);
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
})();

/* ── prayer requests ─────────────────────────────────────────
   Posts to Shopify's contact form rather than throwing the person to a
   success page after sending something personal. */
(function () {
  var form = document.getElementById('prayForm');
  var done = document.getElementById('prayDone');
  var err  = document.getElementById('prayErr');
  if (!form || !done) return;

  form.addEventListener('submit', function (e) {
    var field = form.querySelector('[name="contact[body]"]');
    var email = form.querySelector('[name="contact[email]"]');
    if (err) err.textContent = '';

    if (field && !field.value.trim()) {
      e.preventDefault();
      if (err) err.textContent = 'Add a line about what to pray for, then send it.';
      field.focus();
      return;
    }
    // Shopify rejects the contact form without an email. Anyone who leaves it
    // blank wanted to be anonymous, so send it from the shop's own address.
    if (email && !email.value.trim() && email.dataset.fallback) {
      email.value = email.dataset.fallback;
    }
  });

  // Shopify returns ?contact_posted=true on success, so swap in the done state.
  if (window.location.search.indexOf('contact_posted=true') > -1 &&
      window.location.hash.indexOf('prayer') > -1) {
    form.hidden = true;
    done.hidden = false;
  }
})();


/* ── product size picker ─────────────────────────────────────
   Sets the hidden variant input Shopify's product form submits. Sizes that are
   out of stock are disabled by the template rather than hidden, so the run is
   still legible. */
(function () {
  var form = document.getElementById('buyForm');
  if (!form) return;
  var sizes  = [].slice.call(form.querySelectorAll('.size'));
  var hidden = document.getElementById('buyVariant');
  var err    = document.getElementById('sizeErr');
  if (!sizes.length || !hidden) return;

  var chosen = null;
  sizes.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      sizes.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      chosen = b.dataset.variant;
      hidden.value = chosen;
      if (err) err.textContent = '';
    });
  });

  form.addEventListener('submit', function (e) {
    if (!chosen) {
      e.preventDefault();
      if (err) err.textContent = 'Pick a size first, then we can add it to your cart.';
      sizes[0].focus();
    }
  });
})();

/* ── nav search ──────────────────────────────────────────────
   The field is a panel under the bar, not an input that grows inside it, so
   opening it cannot reflow the logo or the menu. Hidden by default: the
   button is the only affordance until it is asked for. */
(function () {
  var btn  = document.getElementById('navSearchBtn');
  var form = document.getElementById('navSearch');
  if (!btn || !form) return;

  var input = form.querySelector('input[name="q"]');

  var burger = document.querySelector('.nav__burger');
  var menu   = document.getElementById('navMenu');

  function set(open) {
    form.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    // On phones both panels hang off the same bar. Open together they stack
    // and push the page down twice, so opening one closes the other.
    if (open && menu && menu.classList.contains('is-open')) {
      menu.classList.remove('is-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
    }
    if (open && input) input.focus();
  }
  btn.addEventListener('click', function () {
    set(btn.getAttribute('aria-expanded') !== 'true');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { set(false); btn.focus(); }
  });
  document.addEventListener('click', function (e) {
    if (!form.contains(e.target) && !btn.contains(e.target)) set(false);
  });
})();

/* ── order confirmation ──────────────────────────────────────
   The panel is already open when this runs: Liquid renders it that way after a
   successful post, so it survives a script failure. This only handles closing,
   focus, and keeping the page behind from scrolling. */
(function () {
  var veil = document.getElementById('doneVeil');
  if (!veil) return;

  var closers = [document.getElementById('doneClose'),
                 document.getElementById('doneDismiss')].filter(Boolean);
  var lastFocus = document.activeElement;
  var box = veil.querySelector('.done-box');

  document.body.classList.add('is-locked');
  // Focus the panel, not a button: a stray Enter on a focused "Close" would
  // wipe the confirmation before it has been read.
  if (box) { box.setAttribute('tabindex', '-1'); box.focus(); }

  function close() {
    veil.remove();
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  closers.forEach(function (b) { b.addEventListener('click', close); });
  veil.addEventListener('click', function (e) { if (e.target === veil) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Keep tab focus inside the panel while it is up.
  veil.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = veil.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
})();

/* ── cart editing ─────────────────────────────────────────────
   The cart form already works without script (Update cart button, Remove
   links). This adds the − / + steppers and saves a change on its own, after a
   short pause so a few quick taps become one reload. */
(function () {
  var form = document.getElementById('cartForm');
  if (!form) return;
  var update = form.querySelector('.cart-update');
  var timer;

  function save() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      form.classList.add('is-saving');
      // Goes through the Update button so Shopify saves rather than checks out.
      if (form.requestSubmit) form.requestSubmit(update);
      else update.click();
    }, 500);
  }

  form.addEventListener('click', function (e) {
    var step = e.target.closest('.qty__step');
    if (!step) return;
    var input = step.parentNode.querySelector('.qty__input');
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.step, 10));
    input.value = next;
    save();
  });

  form.addEventListener('change', function (e) {
    if (e.target.classList.contains('qty__input')) save();
  });

  // Enter in a quantity box saves now instead of heading to checkout.
  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList.contains('qty__input')) {
      e.preventDefault();
      clearTimeout(timer);
      form.classList.add('is-saving');
      if (form.requestSubmit) form.requestSubmit(update); else update.click();
    }
  });
})();

/* ── text message consent ─────────────────────────────────────
   "No texts" and the two "Yes" boxes cannot both be ticked. Ticking one side
   clears the other; nothing is ever ticked on the customer's behalf. */
(function () {
  var box = document.getElementById('smsConsent');
  if (!box) return;
  var inputs = [].slice.call(box.querySelectorAll('input[data-sms]'));

  // One answer is required. The browser's own validation shows the message on
  // the first box and stops the send, the same way the required fields do.
  function sync() {
    var answered = inputs.some(function (i) { return i.checked; });
    inputs[0].setCustomValidity(answered ? '' : box.dataset.msg);
  }

  box.addEventListener('change', function (e) {
    var t = e.target;
    if (t.checked && t.dataset.sms) {
      var other = t.dataset.sms === 'no' ? 'yes' : 'no';
      box.querySelectorAll('input[data-sms="' + other + '"]').forEach(function (i) { i.checked = false; });
    }
    sync();
  });
  sync();
})();
